import classNames from 'classnames';
import styles from './ColumnModule.module.scss'

export interface ColumnModuleProps {
    children: React.ReactNode;
}

export const ColumnModule: React.FC<ColumnModuleProps> = ({
    children
}) => {
    return (
        <div className={styles.ColumnModule}>
            {children}
        </div>
    );
};